<template>
  <div
    :class="[
      'widget-step',
      { 'active': isActiveStep }
    ]"
    data-test-id="select-asset"
  >
    <StepTitle
      :stepNumber="stepNumber"
      @click.native="$emit('setStep', stepNumber)"
    >
      <div
        class="widget-step__title"
        data-test-id="select-asset-title-container"
      >
        <p data-test-id="select-asset-title">
          {{ i18n.lbl_choose_asset() }}
        </p>
        <p
          v-show="selectedAsset && !isActiveStep"
          data-test-id="selected-asset"
        >
          {{ selectedAsset }}
        </p>
      </div>
    </StepTitle>

    <AccordeonWrapper v-show="isActiveStep">
      <div
        class="widget-step__inner"
        data-test-id="select-asset-container"
      >
        <SelectWrapper
          :options="tokensCodeFormatted"
          :selected="selectedAsset"
          data-test-id="select-asset-selector"
          @setSelected="setSelectedAsset($event)"
          @setOpen="$emit('selectIsOpen', $event)"
        />
        <div
          class="widget-step__swticher"
          data-test-id="select-asset-swtich-container"
        >
          <span>{{ i18n.white_wallet() }}</span>
          <md-switch
            v-model="colorTronSwitch"
            :disabled="!selectedAsset"
            data-test-id="select-asset-swticher"
          />
          <span>{{ i18n.gray_wallet() }}</span>
        </div>
      </div>
    </AccordeonWrapper>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { isNetworkToken, formatTokenCode, sortAssetCodes } from '@utils/consts'

  import StepTitle from '@com/UI/StepTitle.vue'
  import AccordeonWrapper from '@com/UI/AccordeonWrapper.vue'
  import SelectWrapper from '@com/UI/SelectWrapper.vue'

  export default {
    name: 'SelectAsset',
    components: {
      StepTitle,
      AccordeonWrapper,
      SelectWrapper
    },
    props: {
      stepNumber: {
        type: [Number, String],
        required: true
      },
      isActiveStep: {
        type: Boolean,
        default: false
      },
      tokenCodes: {
        type: Array,
        required: true
      }
    },
    emits: ['setStep', 'onAssetSelected', 'setTronColor', 'selectIsOpen'],
    data () {
      return {
        i18n,
        selectedAsset: null,
        colorTronSwitch: false
      }
    },
    computed: {
      tokensCodeFormatted () {
        if (this.tokenCodes) {
          return sortAssetCodes(this.tokenCodes.filter(isNetworkToken))
            .map(formatTokenCode)
        }
        return []
      }
    },
    methods: {
      setSelectedAsset (asset) {
        this.selectedAsset = asset
        this.$emit('onAssetSelected', asset)
      }
    },
    watch: {
      selectedAsset (newVal) {
        if (!newVal && this.colorTronSwitch) this.colorTronSwitch = false
      },
      colorTronSwitch (newVal) {
        this.$emit('setTronColor', newVal)
      }
    }
  }
</script>

<style lang="scss" scoped>
.widget-step {
  &__swticher {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
     margin-top: 10px;

    .md-disabled {
      cursor: not-allowed;
    }
  }

  &__inner {
    /deep/ .md-switch {
      margin: 0;
    }

    /deep/ .vs__dropdown-menu {
      z-index: 100;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/widgets/WithdrawalWidget/SelectAsset.vue